import { SupportDTO, RequestAdviceDTO } from "@iko-design-center/shared"
import * as Sentry from "@sentry/react"
import axios from "axios"

function postDownload(dto: any, applicationType: string): Promise<void> {
  return new Promise((resolve, reject) => {
    axios
      .post<string>(`/api/download/${applicationType}`, dto)
      .then((response) => {
        resolve()
      })
      .catch((e: any) => {
        Sentry.captureException(e)
        reject(e)
      })
  })
}

function postRequestAdvice(dto: RequestAdviceDTO): Promise<void> {
  return new Promise((resolve, reject) => {
    axios
      .post<string>(`/api/request-advice`, dto)
      .then((response) => {
        resolve()
      })
      .catch((e: any) => {
        Sentry.captureException(e)
        reject(e)
      })
  })
}

function postSupport(dto: SupportDTO): Promise<void> {
  return new Promise((resolve, reject) => {
    axios
      .post<string>(`/api/support`, dto)
      .then((response) => {
        resolve()
      })
      .catch((e: any) => {
        Sentry.captureException(e)
        reject(e)
      })
  })
}

export const api = {
  postDownload,
  postRequestAdvice,
  postSupport,
}
